<template>
  <section class="store-edit">
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="150"
    >
      <Card :bordered="false" dis-hover>
        <p slot="title">基础信息</p>
        <Form-item label="门店名称" prop="storeName">
          <Input
            v-model="formValidate.storeName"
            placeholder="请输入"
            style="width: 300px"
          ></Input>
        </Form-item>
        <Form-item
          label="推荐人编码"
          prop="refereeCode"
          v-if="formValidate.refereeCode"
        >
          <span>{{ formValidate.refereeCode }}</span>
          <!-- <Input
            v-model="formValidate.refereeCode"
            disabled
            placeholder="请输入"
            style="width: 300px"
          ></Input> -->
        </Form-item>
        <Form-item label="营业执照" prop="imgLecienceUrl">
          <upload-photo
            :handle-upload="handleUpload"
            photo-name="imgLecienceUrl"
            :default-photo="formValidate.imgLecienceUrl"
          ></upload-photo>
        </Form-item>
        <Form-item label="营业执照编码" prop="lecienceCode">
          <Input
            v-model="formValidate.lecienceCode"
            placeholder="请输入"
            style="width: 300px"
          ></Input>
        </Form-item>
        <Form-item label="营业执照名称" prop="lecienceName">
          <Input
            v-model="formValidate.lecienceName"
            placeholder="请输入"
            style="width: 300px"
          ></Input>
        </Form-item>
        <Form-item label="认证类型" prop="certificateType">
          <RadioGroup v-model="formValidate.certificateType">
            <Radio label="00">
              <span>三证合一</span>
            </Radio>
            <Radio label="01">
              <span>三证</span>
            </Radio>
          </RadioGroup>
        </Form-item>
        <div>
          <Form-item label="组织机构代码编码" prop="orginizeCode">
            <Input
              v-model="formValidate.orginizeCode"
              placeholder="请输入组织机构代码编码"
              style="width: 300px"
            ></Input>
          </Form-item>
          <Form-item label="税务登记证编码" prop="taxlienceType">
            <Input
              v-model="formValidate.taxlienceType"
              placeholder="请输入税务登记证编码"
              style="width: 300px"
            ></Input>
          </Form-item>
        </div>
        <Form-item label="店内照片" prop="shopInImg">
          <upload-photo
            :handle-upload="handleUpload"
            photo-name="shopInImg"
            :default-photo="formValidate.shopInImg"
          ></upload-photo>
        </Form-item>
        <Form-item label="门牌号照片" prop="shopNumImg">
          <upload-photo
            :handle-upload="handleUpload"
            photo-name="shopNumImg"
            :default-photo="formValidate.shopNumImg"
          ></upload-photo>
        </Form-item>
        <Form-item label="业务员手机号" prop="businessMobile">
          <Input
            v-model="formValidate.businessMobile"
            placeholder="请输入"
            style="width: 300px"
            type="tel"
            :maxlength="11"
          ></Input>
        </Form-item>
        <Form-item label="联系人" prop="contactPerson">
          <Input
            v-model="formValidate.contactPerson"
            placeholder="请输入"
            style="width: 300px"
          ></Input>
        </Form-item>
        <Form-item label="联系人手机号" prop="contactMobile">
          <Input
            v-model="formValidate.contactMobile"
            placeholder="请输入"
            style="width: 300px"
            type="tel"
            :maxlength="11"
          ></Input>
        </Form-item>
        <Form-item label="所属地区" prop="storeArea" style="position: relative">
          <Input
            v-model="formValidate.storeAreaName"
            placeholder="请输入"
            style="
              width: 300px;
              position: absolute;
              left: 0;
              top: 0;
              z-index: 999;
              pointer-events: none;
            "
          ></Input>
          <Cascader
            placeholder=""
            :data="addressData"
            @on-change="changeStoreArea"
            style="width: 300px"
            :load-data="loadData"
          ></Cascader>
        </Form-item>
        <Form-item label="详细地址" prop="storeAddress">
          <div>
            <Input
              v-model="formValidate.storeAddress"
              placeholder="请输入"
              style="width: 300px"
            ></Input>
            <Button style="margin-left: 20px" @click="changeArea">搜索</Button>
          </div>
          <amap-controls style="margin-top: 20px"></amap-controls>
          <!-- <div style="margin-top: 10px">
            <Input
              disabled
              v-model="formValidate.storeAddress"
              style="width: 500px"
              type="textarea"
            ></Input>
          </div> -->
        </Form-item>
        <Form-item label="平台资金商" prop="dealerCode">
          <span>{{ getDealerName() }}</span>
          <!-- <Select
            disabled
            v-model="formValidate.dealerCode"
            placeholder="请选择"
            style="width: 300px"
          >
            <template v-for="(item, index) in spInfoQueryAllList">
              <Option :key="item.code" :value="item.code" v-if="item.stype == '0'"
                >{{ item.name }}
              </Option>
            </template>
          </Select> -->
        </Form-item>
        <Form-item label="渠道编码" prop="channelCode">
          <Select
            v-model="formValidate.channelCode"
            placeholder="请选择"
            style="width: 300px"
          >
            <Option
              :key="index"
              :value="item.value"
              v-for="(item, index) in channelInfoqQueryList"
              >{{ item.label }}
            </Option>
          </Select>
        </Form-item>
        <Form-item label="平台编码" prop="platformCode">
          <Select
            v-model="formValidate.platformCode"
            placeholder="请选择"
            style="width: 300px"
          >
            <Option
              :key="index"
              :value="item.value"
              v-for="(item, index) in platformCodeList"
              >{{ item.label }}
            </Option>
          </Select>
        </Form-item>
        <Form-item label="平台服务商" prop="serviceCode">
          {{ getServiceName() }}
          <!-- <Select
            disabled
            v-model="formValidate.serviceCode"
            placeholder="请选择"
            style="width: 300px"
          >
            <template v-for="(item, index) in spInfoQueryAllList">
              <Option
                :key="index"
                :value="item.parentCode"
                v-if="item.stype == '1'"
                >{{ item.name }}
              </Option>
            </template>
          </Select> -->
        </Form-item>
        <!-- <Form-item label="用户类型" prop="userType">
          <span>{{getUserType()}}</span> -->
        <!-- <Select
            disabled
            v-model="formValidate.userType"
            placeholder="请选择"
            style="width: 300px"
          >
            <Option
              :key="index"
              :value="item.id"
              v-for="(item, index) in userTypeQueryAllList"
              >{{ item.typeName }}
            </Option>
          </Select> -->
        <!-- </Form-item> -->
        <Form-item label="erp代码" prop="erpCode">
          <Input
            v-model="formValidate.erpCode"
            placeholder="请输入"
            style="width: 300px"
          ></Input>
        </Form-item>
        <Form-item label="mdm代码" prop="mdmCode">
          <Input
            v-model="formValidate.mdmCode"
            placeholder="请输入"
            style="width: 300px"
          ></Input>
        </Form-item>
        <Form-item label="planAccount" prop="planAccount">
          <span>{{ formValidate.planAccount }}</span>
          <!-- <Input
            disabled
            v-model="formValidate.planAccount"
            placeholder="请输入"
            style="width: 300px"
          ></Input> -->
        </Form-item>
        <Form-item label="是否可以下单" prop="canOrder">
          <!-- <span>{{formValidate.canOrder === '0' ? '不能下单' : formValidate.canOrder === '1' ? '不能下单' : ''}}</span> -->
          <RadioGroup v-model="formValidate.canOrder">
            <Radio label="0">
              <span>不能下单</span>
            </Radio>
            <Radio label="1">
              <span>能下单</span>
            </Radio>
          </RadioGroup>
        </Form-item>
        <Form-item label="门店状态" prop="status">
          <Select
            v-model="formValidate.status"
            placeholder="请选择"
            style="width: 300px"
          >
            <Option
              :key="index"
              :value="item.value"
              v-for="(item, index) in statusList"
              >{{ item.label }}
            </Option>
          </Select>
        </Form-item>
      </Card>
      <Card :bordered="false" dis-hover>
        <p slot="title">开票信息</p>
        <Form-item label="发票类型" prop="invoiceType">
          <RadioGroup v-model="formValidate.invoiceType">
            <Radio :label="1">
              <span>增值税专用发票</span>
            </Radio>
            <Radio :label="2">
              <span>增值税普通发票</span>
            </Radio>
          </RadioGroup>
        </Form-item>
        <Form-item label="开户账号" prop="bankAccount">
          <Input
            v-model="formValidate.bankAccount"
            placeholder="请输入"
            style="width: 300px"
          ></Input>
        </Form-item>
        <Form-item label="开户银行" prop="bankName">
          <Input
            v-model="formValidate.bankName"
            placeholder="请输入"
            style="width: 300px"
          ></Input>
        </Form-item>
        <Form-item label="单位地址" prop="companyAddress">
          <Input
            v-model="formValidate.companyAddress"
            placeholder="请输入"
            style="width: 300px"
          ></Input>
        </Form-item>
        <Form-item label="开票公司" prop="invoiceCompany">
          <Input
            v-model="formValidate.invoiceCompany"
            placeholder="请输入"
            style="width: 300px"
          ></Input>
        </Form-item>
        <Form-item label="联系电话" prop="invoiceMobile">
          <Input
            v-model="formValidate.invoiceMobile"
            placeholder="请输入"
            style="width: 300px"
            type="tel"
          ></Input>
        </Form-item>
        <Form-item label="税号" prop="invoiceNumber">
          <Input
            v-model="formValidate.invoiceNumber"
            placeholder="请输入"
            style="width: 300px"
          ></Input>
        </Form-item>
        <Form-item label="发票主体营业执照" prop="invoiceImgLecienceUrl">
          <upload-photo
            :handle-upload="handleUpload"
            photo-name="invoiceImgLecienceUrl"
            :default-photo="formValidate.invoiceImgLecienceUrl"
          ></upload-photo>
        </Form-item>
        <Form-item label="发票收件人姓名" prop="invoiceReceiveName">
          <Input
            v-model="formValidate.invoiceReceiveName"
            placeholder="请输入"
            style="width: 300px"
          ></Input>
        </Form-item>
        <Form-item label="发票收件人手机号" prop="invoiceReceivePhone">
          <Input
            v-model="formValidate.invoiceReceivePhone"
            placeholder="请输入"
            style="width: 300px"
          ></Input>
        </Form-item>
        <Form-item label="发票收件人地址" prop="invoiceReceiveAddr">
          <Input
            v-model="formValidate.invoiceReceiveAddr"
            placeholder="请输入"
            style="width: 300px"
          ></Input>
        </Form-item>
        <Form-item label="专票授权文件" prop="specialInvoiceAuthDocUrl">
          <upload-photo
            :handle-upload="handleUpload"
            photo-name="specialInvoiceAuthDocUrl"
            :default-photo="formValidate.specialInvoiceAuthDocUrl"
          ></upload-photo>
        </Form-item>
      </Card>
      <Card :bordered="false" dis-hover>
        <p slot="title">经营信息</p>
        <Form-item label="门店类型" prop="retType">
          <span>{{ getRetType() }}</span>
          <!-- <RadioGroup v-model="formValidate.retType">
            <Radio
              disabled
              :key="index"
              :label="item.value"
              v-for="(item, index) in retailerTypeQueryList"
            >
              <span>{{ item.label }}</span>
            </Radio>
          </RadioGroup> -->
        </Form-item>
        <Form-item label="食品经营许可证号" prop="fblCode">
          <Input
            v-model="formValidate.fblCode"
            placeholder="请输入"
            style="width: 300px"
          ></Input>
        </Form-item>
        <Form-item label="食品许可证" prop="fblImgUrl">
          <upload-photo
            :handle-upload="handleUpload"
            photo-name="fblImgUrl"
            :default-photo="formValidate.fblImgUrl"
          ></upload-photo>
        </Form-item>
      </Card>
      <Card :bordered="false" dis-hover>
        <p slot="title">收货信息</p>
        <Form-item label="联系人" prop="receivePerson">
          <Input
            v-model="formValidate.receivePerson"
            placeholder="请输入"
            style="width: 300px"
          ></Input>
        </Form-item>
        <Form-item label="联系人手机号" prop="receiveMobile">
          <Input
            v-model="formValidate.receiveMobile"
            placeholder="请输入"
            style="width: 300px"
            type="tel"
            :maxlength="11"
          ></Input>
        </Form-item>
        <Form-item label="所属地区" prop="atpids">
          <Input
            v-model="formValidate.atnames"
            placeholder="请输入"
            style="
              width: 300px;
              position: absolute;
              left: 0;
              top: 0;
              z-index: 999;
              pointer-events: none;
            "
          ></Input>
          <Cascader
            placeholder=""
            :data="addressData"
            @on-change="changeAtpids"
            style="width: 300px"
            :load-data="loadData"
          ></Cascader>
        </Form-item>
        <Form-item label="详细地址" prop="receiveAddr">
          <Input
            v-model="formValidate.receiveAddr"
            placeholder="请输入"
            style="width: 500px"
            type="textarea"
          ></Input>
        </Form-item>
      </Card>
      <FormItem class="br mfooter">
        <Button @click="handleReset">取消</Button>
        <Button @click="handleSave" type="primary" style="margin-left: 10px"
          >保存</Button
        >
      </FormItem>
    </Form>
  </section>
</template>

<script>
import axios from "axios";
import { initFormValidate, ruleValidate } from "./validate/rule";
import uploadPhoto from "@/views/store/components/uploadPhoto";
import amapControls from "@/views/store/components/amapControls";

export default {
  name: "store-edit",
  components: {
    uploadPhoto,
    amapControls,
  },
  data() {
    const { retCode } = this.$route.query;
    return {
      formValidate: initFormValidate,
      ruleValidate: ruleValidate,
      retCode: retCode,
      addressData: [],
      // addressArray: [],
      userTypeQueryAllList: [],
      spInfoQueryAllList: [],
      channelInfoqQueryList: [
        { label: "GT", value: "GT" },
        { label: "KA", value: "KA" },
        { label: "OTHERS", value: "OTHERS" },
      ],
      retailerTypeQueryList: [
        { label: "直接订货门店", value: "0" },
        { label: "总仓配货门店", value: "1" },
        { label: "总仓和门店", value: "2" },
        { label: "总仓", value: "3" },
        { label: "联盟总店", value: "21" },
        { label: "联盟分店", value: "22" },
      ],
      platformCodeList: [
        { label: "易购APP", value: "0001" },
        { label: "微信小程序门店版", value: "0002" },
        { label: "易掌柜", value: "0003" },
        { label: "业务管理后台", value: "0004" },
      ],
      statusList: [
        { label: "正常", value: "0" },
        { label: "停用", value: "1" },
        { label: "审核失败", value: "2" },
        { label: "冻结", value: "3" },
        { label: "关店", value: "4" },
        { label: "待审核", value: "5" },
      ],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.getShopInfo();
      this.getUserTypeQueryAll();
      this.getSpInfoQueryAll();
    },
    // 资金商列表
    getSpInfoQueryAll() {
      this.$api["spInfoQueryAll"]().then(({ data }) => {
        this.spInfoQueryAllList = data;
      });
    },
    getUserTypeQueryAll() {
      this.$api["userTypeQueryAll"]().then(({ data }) => {
        this.userTypeQueryAllList = data;
      });
    },
    getShopInfo() {
      this.getBaseAreaQueryAll().then((res) => {
        this.addressData = res;
      });
      if (!this.retCode) return false;
      const params = {
        code: this.retCode,
      };
      this.$api["shopInfoQuery"](params).then(async ({ data }) => {
        let storeArea = data.storeArea
          ? data.storeArea.split("-").map((d, i, o) => {
              return o.slice(0, i + 1).join("-");
            })
          : [];
        storeArea.length && storeArea.shift();
        let atpids =
          data.shippingAddr && data.shippingAddr.atpids
            ? data.shippingAddr.atpids.split("-").map((d, i, o) => {
                return o.slice(0, i + 1).join("-");
              })
            : [];
        atpids.length && atpids.shift();
        //处理地理位置
        // const addressData = await this.getBaseAreaQueryAll();
        // this.addressData = addressData;
        const len = storeArea.length;
        let storeAreaName = "";
        const storeAreaData = await this.getBaseAreaQueryAll(
          storeArea[len - 2].split("-").pop()
        );
        storeAreaData.forEach((d) => {
          if (d.value === storeArea[len - 1]) {
            storeAreaName = d.label;
            this.changeArea(d.label);
          }
        });
        this.formValidate = Object.assign(data, {
          storeName: data.retName,
          storeAddress: data.addr,
          receivePerson: data.shippingAddr.receivePerson,
          receiveMobile: data.shippingAddr.receiveMobile,
          receiveAddr: data.shippingAddr.addr,
          atnames: data.shippingAddr.atnames,
          storeArea: storeArea,
          atpids: atpids,
          storeAreaName,
        });
        if (Array.isArray(data.retailerPhotos)) {
          data.retailerPhotos.map((item) => {
            switch (item.imgName) {
              case "店内照片":
                this.formValidate.shopInImg = item.imgUrl;
                break;
              case "门牌号照片":
                this.formValidate.shopNumImg = item.imgUrl;
                break;
              case "食品许可证照片":
                this.formValidate.fblImgUrl = item.imgUrl;
                break;
              default:
                break;
            }
          });
        }
      });
    },
    changeArea(label) {
      if (typeof label === "string") {
        this.$bus.$emit(
          "searchAddress",
          label + this.formValidate.storeAddress
        );
      } else {
        this.$bus.$emit(
          "searchAddress",
          this.formValidate.storeAreaName + this.formValidate.storeAddress
        );
      }
    },
    async loadData(item, callback) {
      if (item.loading != null) item.loading = true;
      const addressData = await this.getBaseAreaQueryAll(
        item.value.split("-").pop()
      );
      if (addressData.length) {
        item.children = addressData;
      }
      if (item.loading != null) item.loading = false;
      callback();
    },
    async getBaseAreaQueryAll(code = "") {
      const params = {
        code,
      };
      const { data } = await this.$api["queryForShop"](params);
      const addressData = this.convertAddressTree(data);
      return addressData;
    },
    handleUpload(v, name) {
      this.formValidate[name] = v;
    },
    handleReset() {
      this.formValidate = initFormValidate;
      this.$refs["formValidate"].resetFields();
      this.$router.back(-1);
    },
    async handleSave() {
      this.$refs["formValidate"].validate(async (valid) => {
        if (valid) {
          let params = Object.assign({}, this.formValidate, {
            atpids: this.formValidate.atpids.pop(),
            storeArea: this.formValidate.storeArea.pop(),
          });
          delete params.retailerPhotos;
          delete params.retailerUser;
          delete params.shippingAddr;
          const { data, code } = this.retCode
            ? await this.$api["shopInfoUpdate"](params)
            : await this.$api["shopInfoAdd"](params);
          if (code == "200") {
            this.$Message.success(`${this.retCode ? "更新" : "新增"}门店成功`);
            this.$router.back(-1);
          }
        }
      });
    },
    convertAddressTree(tree) {
      tree.forEach((item) => {
        if (item.children != 0) {
          item.children = [];
          item.loading = false;
        } else {
          delete item.children;
        }
      });
      return tree;
    },

    getRetType() {
      const res = this.retailerTypeQueryList.filter(
        (d) => d.value == this.formValidate.retType
      );
      if (res.length) {
        return res[0].label;
      }
    },

    getUserType() {
      const res = this.userTypeQueryAllList.filter(
        (d) => d.id == this.formValidate.userType
      );
      if (res.length) {
        return res[0].typeName;
      }
    },

    getServiceName() {
      const res = this.spInfoQueryAllList.filter(
        (d) => d.code == this.formValidate.serviceCode && d.stype == "1"
      );
      if (res.length) {
        return res[0].name;
      }
    },

    getDealerName() {
      const res = this.spInfoQueryAllList.filter(
        (d) => d.code == this.formValidate.dealerCode && d.stype == "0"
      );
      if (res.length) {
        return res[0].name;
      }
    },

    changeStoreArea(value, selectedData) {
      console.log(value);
      const len = selectedData.length;
      this.formValidate.storeArea = value;
      this.formValidate.storeAreaName = selectedData[len - 1].label;
    },
    changeAtpids(value, selectedData) {
      const len = selectedData.length;
      this.formValidate.atpids = value;
      this.formValidate.atnames = selectedData[len - 1].label;
    },
  },
};
</script>

<style scoped>
.store-edit .ivu-form-item {
  margin-bottom: 20px;
}
.mfooter {
  position: fixed;
  right: 25px;
  bottom: -20px;
  z-index: 1000;
  padding: 10px 0;
  width: 80%;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/store/storeEdit.vue